/* HeartfeltVerse: progressive enhancement only. Article content is fully server rendered. */
(function () {
  'use strict';
  function initArticle(root) {
    if (root.dataset.hvReady === 'true') return;
    root.dataset.hvReady = 'true';
    var prose = root.querySelector('[data-hv-prose]');
    if (!prose) return;

    // Add navigable anchors to the existing H2 and selected H3 headings.
    var headings = Array.from(prose.querySelectorAll('h2, h3'));
    var slugs = new Set();
    var tocItems = [];
    headings.forEach(function (heading, index) {
      var text = (heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;
      if (!heading.id) {
        var base = text.normalize('NFKD').toLowerCase()
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 68) || ('section-' + (index + 1));
        var candidate = base;
        var suffix = 2;
        while (slugs.has(candidate) || document.getElementById(candidate)) {
          candidate = base + '-' + suffix++;
        }
        heading.id = candidate;
      }
      slugs.add(heading.id);
      tocItems.push({id: heading.id, title: text, level: heading.tagName.toLowerCase()});
    });

    var h2Count = tocItems.filter(function (item) { return item.level === 'h2'; }).length;
    var includeH3 = tocItems.length <= 17; // avoid overwhelming navigation on long quote lists
    var displayed = tocItems.filter(function (item) { return item.level === 'h2' || includeH3; }).slice(0, 24);
    if (h2Count >= 2) {
      root.querySelectorAll('[data-hv-toc]').forEach(function (nav) {
        var list = nav.querySelector('[data-hv-toc-list]');
        if (!list) return;
        displayed.forEach(function (item) {
          var li = document.createElement('li');
          if (item.level === 'h3') li.className = 'hv-toc__item--sub';
          var link = document.createElement('a');
          link.href = '#' + encodeURIComponent(item.id);
          link.textContent = item.title;
          li.appendChild(link);
          list.appendChild(li);
        });
        nav.hidden = false;
      });
    }

    // Users can copy individual original messages and quotations with one tap.
    prose.querySelectorAll('blockquote').forEach(function (quote) {
      if (quote.querySelector('.hv-quote-copy')) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'hv-quote-copy';
      button.textContent = 'Copy';
      button.setAttribute('aria-label', 'Copy this passage');
      button.addEventListener('click', function () {
        var cloned = quote.cloneNode(true);
        cloned.querySelectorAll('.hv-quote-copy').forEach(function (node) { node.remove(); });
        var value = (cloned.innerText || cloned.textContent || '').trim().replace(/\s{2,}/g, ' ');
        if (!value) return;
        copyText(value).then(function () {
          button.textContent = 'Copied!';
          button.dataset.copied = 'true';
          setTimeout(function () { button.textContent = 'Copy';button.dataset.copied = 'false'; }, 1700);
        }).catch(function () { button.textContent = 'Select to copy'; });
      });
      quote.appendChild(button);
    });

    root.querySelectorAll('[data-hv-copy-url]').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.dataset.copyText || location.href;
        copyText(value).then(function () {
          var label = button.querySelector('[data-hv-copy-label]');
          if (!label) return;
          label.textContent = 'Copied!';
          setTimeout(function () { label.textContent = 'Copy link'; }, 1700);
        }).catch(function () { window.prompt('Copy this link:', value); });
      });
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {document.execCommand('copy') ? resolve() : reject(new Error('Copy unavailable'));}
      catch (error) {reject(error);}
      textarea.remove();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-hv-article-root]').forEach(initArticle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
